import React, { Component } from 'react'
import './Center.css'
import Posts from './Center_Components/Posts/Posts';
import Manager from './Center_Components/Manager/Manager';
import Timesheet from './Center_Components/Timesheet/Timesheet';
import TimesheetReport from './Reports/TimesheetReport';
import TimesheetMovementList from './Center_Components/TimesheetMovement/TimesheetMovementList';
import UsersContainer from './Center_Components/Users/Users';
import TimesheetDocList from './Center_Components/TimesheetDocList/TimesheetDocList';
import Holidays from './Center_Components/Holidays/Holidays';

export default class Center extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: 0,
            option_name: null,
            openUserlist: false,
            SureDel: -1,
            openUserlist: false,
        }
    }
    OpenSelectorOptions = (options, option_name) => {
        this.setState({ options, option_name })
    }
    activeUpdateRow(activerow, activerow_ind) {
        this.setState({ activerow, activerow_ind })
    }
    plusInsertRow(insertRow) {
        this.setState({ insertRow })
    }
    sureDelete(SureDel, t_fio_delete, id_timesheet_user) {
        this.setState({ SureDel, t_fio_delete, id_timesheet_user })
    }

    openUserList = () => {
        this.setState(prevState => ({
            openUserlist: !prevState.openUserlist
        }));
    }

    render() {
        return (
            <div className="Center_container" onClick={() => this.state.options === 1 ? this.OpenSelectorOptions(0, null) : null}
                onMouseLeave={() => this.state.options === 1 ? this.OpenSelectorOptions(0, null) : null}>

                {this.props.selected_menu === 0 ?
                    <h2>У вас пока нету роли для данной программы, обратитксь к администратору</h2>
                    : null
                }

                {this.props.selected_menu === 1 ?
                    <Timesheet {...this.state} {...this.props}
                        OpenSelectorOptions={this.OpenSelectorOptions.bind(this)}
                        sureDelete={this.sureDelete.bind(this)}
                    /> : null
                }

                {this.props.selected_menu === 2 ?
                    <Posts {...this.state} {...this.props}
                        OpenSelectorOptions={this.OpenSelectorOptions.bind(this)}
                        plusInsertRow={this.plusInsertRow.bind(this)}
                        activeUpdateRow={this.activeUpdateRow.bind(this)}
                        sureDelete={this.sureDelete.bind(this)}
                    /> : null
                }

                {this.props.selected_menu === 3 ?
                    <UsersContainer {...this.state} {...this.props}
                        OpenSelectorOptions={this.OpenSelectorOptions.bind(this)}
                        plusInsertRow={this.plusInsertRow.bind(this)}
                        activeUpdateRow={this.activeUpdateRow.bind(this)}
                        sureDelete={this.sureDelete.bind(this)}
                        openUserList={this.openUserList.bind(this)}
                    /> : null
                }

                {this.props.selected_menu === 4 ?
                    <Manager {...this.state} {...this.props}
                        OpenSelectorOptions={this.OpenSelectorOptions.bind(this)}
                        plusInsertRow={this.plusInsertRow.bind(this)}
                        activeUpdateRow={this.activeUpdateRow.bind(this)}
                        sureDelete={this.sureDelete.bind(this)}
                        openUserList={this.openUserList.bind(this)}
                    /> : null
                }

                {this.props.selected_menu === 8 ?
                    <Holidays {...this.state} {...this.props}
                        OpenSelectorOptions={this.OpenSelectorOptions.bind(this)}
                        plusInsertRow={this.plusInsertRow.bind(this)}
                        activeUpdateRow={this.activeUpdateRow.bind(this)}
                        sureDelete={this.sureDelete.bind(this)}
                    /> : null
                }

                {this.props.selected_menu === 5 ?
                    <TimesheetReport {...this.state} {...this.props}
                        OpenSelectorOptions={this.OpenSelectorOptions.bind(this)}
                    /> : null
                }

                {this.props.selected_menu === 6 ?
                    <TimesheetMovementList {...this.state} {...this.props}
                        OpenSelectorOptions={this.OpenSelectorOptions.bind(this)}
                    /> : null
                }

                {this.props.selected_menu === 7 ?
                    <TimesheetDocList {...this.state} {...this.props}
                        OpenSelectorOptions={this.OpenSelectorOptions.bind(this)}
                    /> : null
                }


            </div>

        )
    }
}
